<template>
  <div
    :class="prefixCarouselItemClass"
    :style="styles">
    <slot/>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
const PREFIX_CAROUSEL_ITEM_CLASS = `${PREFIX_CLASS}carousel-item`
export default {
  componentName: 'carouselItem',
  name: 'TaurusCarouselItem',
  data () {
    return {
      height: 'auto',
      left: 0
    }
  },
  computed: {
    prefixCarouselItemClass () {
      return PREFIX_CAROUSEL_ITEM_CLASS
    },
    styles () {
      return {
        height: `${this.height}`,
        left: `${this.left}px`
      }
    }
  },
  mounted () {
    this.$parent.slotChange()
  },
  beforeDestroy () {
    this.$parent.slotChange()
  }
}
</script>


// WEBPACK FOOTER //
// carousel-item.vue?d2aced26